export default __webpack_public_path__ + "static/media/a.927d78d7.png";